import React from "react";
import { AgCharts } from "ag-charts-react";
const Dashboardgraph = ({ data }) => {
  return (
    <>
      <div className="w-full grid grid-cols-2 gap-5">
        {data.length > 0
          ? data.map((category) => {
              const chartData = category?.article?.map((item) => ({
                title: item.article_title,
                count: item.count,
              }));

              const options = {
                title: {
                  text: category.title,
                  fontSize: 18,
                },
                data: chartData,
                series: [
                  {
                    type: "bar",
                    xKey: "title",
                    yKey: "count",
                    yName: "Count",
                    fill: "#FEB13F ",
                    label: {
                      enabled: true,
                      color: "black",
                      fontSize: 14,
                      placement: "outside",
                      formatter: ({ value }) => value.toString(),
                    },
                  },
                ],

                axes: [
                  {
                    type: "category",
                    position: "bottom",
                    title: { text: "Articles" },
                  },
                  {
                    type: "number",
                    position: "left",
                    title: { text: "Count" },
                  },
                ],
                height: 400,
              };

              return (
                <div key={category.c_id} style={{ marginBottom: "40px" }}>
                  <AgCharts options={options} />
                </div>
              );
            })
          : "No Data to Show"}
      </div>
    </>
  );
};

export default Dashboardgraph;
